/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { getAddressDetailAsync } from '../generated/DataActionExtension.g';
import { IDXC_GetNZPostAddressDetailResponse } from '../generated/DataServiceEntities.g';

/**
 * GetNZPostAddressActionInput Input Action
 */

export class GetNZPostAddressDetailsActionInput implements IActionInput {
    public addressId: string;

    // Construct the input needed to run the action
    constructor(addressId: string) {
        this.addressId = addressId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'GetNZAddressDetailsResponse2020';
    public getCacheObjectType = () => 'GetNZAddressDetailsResponse';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: GetNZPostAddressDetailsActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getNZAddressResponseDetailsAction(
    input: GetNZPostAddressDetailsActionInput,
    ctx: IActionContext
): Promise<IDXC_GetNZPostAddressDetailResponse> {
    let addressDetailsResult: IDXC_GetNZPostAddressDetailResponse = { success: false };
    return getAddressDetailAsync({ callerContext: ctx }, input.addressId)
        .then((response) => {
            if (response && !(response instanceof Error)) {
                addressDetailsResult = response;
                return addressDetailsResult;
            } else {
                return addressDetailsResult;
            }
        })
        .catch((error: Error) => {
            ctx.trace(error.message);
            return addressDetailsResult;
        });
}

export const ISubmitSubscribeFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_GetNZPostAddressDetailResponse>>getNZAddressResponseDetailsAction,
    input: createInput
});
